/**
 * Represents an error that occurs when there is a signature duplicate
 */
class SignatureDuplicateEventError extends Error {
    constructor(public readonly message: string, innerError?: Error) {
        super(message, innerError);
        this.name = "SignatureEventError";

    }
}

const isSignatureDuplicateEventError = (
    error: unknown
): error is SignatureDuplicateEventError => {
    return error instanceof SignatureDuplicateEventError;
};

export { SignatureDuplicateEventError, isSignatureDuplicateEventError };
